import {createDataStore} from './createDataStore';

// Caches /data/machineLearningData.json for the ML basics/concepts pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
export const useMlDataStore = createDataStore(
    '/data/machineLearningData.json',
    'ml-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses']
);
